<div id="header">
	<div class="header-container">
		<img class="serp-logo" src="assets/logos/serp-logo.png" alt="">
		<div class="header-text-container mt-1">
			<h1 class="serp-ap mt-0">SERP AP</h1>
			<p class="agriculture-marketplace">Agriculture Marketplace</p>
		</div>
	</div>
</div>